"use client";

import { ChevronDown } from "lucide-react";
import type { ReactNode } from "react";

type CcCalculatorCollapsibleProps = {
  id: string;
  label: string;
  open: boolean;
  onToggle: () => void;
  disabled?: boolean;
  summary?: ReactNode;
  children: ReactNode;
};

/** Expand/collapse block used for calculator assumptions and methodology copy. */
export function CcCalculatorCollapsible({
  id,
  label,
  open,
  onToggle,
  disabled = false,
  summary,
  children,
}: CcCalculatorCollapsibleProps) {
  return (
    <div className="cc-traffic__assumptions">
      <div className="cc-traffic__assumptions-bar">
        <button
          type="button"
          className="cc-traffic__toggle"
          aria-expanded={open}
          aria-controls={id}
          onClick={onToggle}
          disabled={disabled}
        >
          {label}
          <ChevronDown size={14} strokeWidth={2} aria-hidden />
        </button>
        {summary ? <div className="cc-traffic__summary">{summary}</div> : null}
      </div>
      <div
        id={id}
        className="cc-traffic__assumptions-body"
        data-open={open ? "true" : "false"}
        aria-hidden={!open}
      >
        <div className="cc-traffic__assumptions-collapse">
          <div className="cc-traffic__assumptions-fields" inert={open ? undefined : true}>
            {children}
          </div>
        </div>
      </div>
    </div>
  );
}

type CcCalculatorHowCollapsibleProps = {
  id: string;
  label: string;
  open: boolean;
  onToggle: () => void;
  lines: string[];
};

export function CcCalculatorHowCollapsible({
  id,
  label,
  open,
  onToggle,
  lines,
}: CcCalculatorHowCollapsibleProps) {
  return (
    <div className="cc-traffic__how">
      <button
        type="button"
        className="cc-traffic__toggle"
        aria-expanded={open}
        aria-controls={id}
        onClick={onToggle}
      >
        {label}
        <ChevronDown size={14} strokeWidth={2} aria-hidden />
      </button>
      <div
        id={id}
        className="cc-traffic__how-body"
        data-open={open ? "true" : "false"}
        aria-hidden={!open}
      >
        <div className="cc-traffic__how-collapse">
          <div className="cc-traffic__how-content" inert={open ? undefined : true}>
            {lines.map((line) => (
              <p key={line}>{line}</p>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
